import React from 'react';
import {Button} from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import RestoreVersionDialog from './RestoreVersionDialog';
import {useRestoreVersion} from './useRestoreVersion';

/**
 * Inline restore action for the selected historical version in the version sidebar.
 */
const RestoreVersionButton = ({reportId, version, latestVersion, disabled, onClick}) => {
    const {
        canRestore,
        confirmOpen,
        restoring,
        error,
        openConfirm,
        closeConfirm,
        handleRestore,
    } = useRestoreVersion({reportId, version, latestVersion, disabled});

    if (!canRestore) {
        return null;
    }

    const handleClick = (event) => {
        event.stopPropagation();
        onClick?.(event);
        openConfirm();
    };

    return (
        <>
            <Button
                fullWidth
                variant="outlined"
                color="warning"
                size="small"
                startIcon={<HistoryIcon/>}
                disabled={disabled || restoring}
                onClick={handleClick}
                sx={{mt: 1}}
            >
                Restore this version
            </Button>

            <RestoreVersionDialog
                open={confirmOpen}
                version={version}
                restoring={restoring}
                error={error}
                onClose={closeConfirm}
                onConfirm={handleRestore}
            />
        </>
    );
};

export default RestoreVersionButton;
